import React from 'react';
import { Outlet, NavLink } from "react-router-dom";

const Layout = () => {
  return (
    <>
    <nav className=' bg-dark'>
      <ul className='cnav'>
        <li>
          <NavLink to="/about" activeclassname="selected" >About</NavLink>
        </li>
        <li>
          <NavLink to="/search" activeclassname="selected">Search</NavLink>
        </li>
        <li>
          <NavLink to="/contact" activeclassname="selected">Contact</NavLink>
        </li>
        <li>
          <NavLink to="/user/Moobeen/Quader" activeclassname="selected">User</NavLink>
        </li>
      </ul>
    </nav>

    <Outlet />
  </>
  );
};

export default Layout;
